export default __webpack_public_path__ + "static/media/save.e5819f30.svg";